import React, { Component } from 'react';
import moment from "moment";
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import DateRange from '../DateRange';
import AvailabilitySlots from './components/AvailabilitySlots';
import NoAvailability from './components/NoAvailability';
import * as api from '../../services/api/search';

class AvailabilityGrid extends Component {
  state = {
    dateRange: [],
    availabilities: {},
    nextAvailability: {},
    isLoading: true,
    startDate: null,
  };

  // called on componentDidMount
  setDateRange = dateRange => {
    this.setState({ dateRange, startDate: null });
    this.setAvailability(dateRange);
  };

  setAvailability = async dateRange => {
    const { provider, onError } = this.props;
    const offset = new Date().getTimezoneOffset();

    try {
      this.setState({ isLoading: true });
      await this.fetchAvailability(provider, dateRange, offset);
    this.props.setObKey(this.props.nxKey)
    } catch (err) {
      console.error(err);
      onError(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  fetchAvailability = async (provider, dateRange, offset) => {
    let from = dateRange[0].toISOString();
    let tenancyIds=[]
    if(provider.tenancyType=='telemedicine'){
      tenancyIds = provider.tenancies.filter(t => t.zipcode === 'telemedicine').map(item => item.id);
    }
    else{
      tenancyIds = provider.tenancies.map(item => item.id);
    }
    if (moment(from).isSameOrBefore(moment())) {
      from = moment();
    }
    const to = dateRange[dateRange.length - 1].toISOString();
    // const range = {
    //   from: dateRange[0].toISOString(),
    //   to: dateRange[dateRange.length - 1].format('YYYY-MM-DD'),
    // };
    
    const availabilities = await api.fetchClientAvailability(provider, {
      from,
      to,
    }, offset, tenancyIds);
    this.setState({ availabilities });

    if (isEmpty(availabilities)) {
      const nextAvailability = await api.fetchNextAvailability(
        provider,
        dateRange[0].toISOString(),
        tenancyIds
      );

      this.setState({ nextAvailability });
    }
  };

  hasNoAvailability = () => {
    const { isLoading, availabilities } = this.state;
    return !isLoading && isEmpty(availabilities);
  };

  fastForwardDateRange = ({ startDate }) => {
    this.setState({ startDate });
  };
  
 
  render() {
    const {
      classes,
      provider,
      appointmentSelected,
      referPatientCallback,
      Loading,
      objKey,
      nxKey,
      obKey,
    } = this.props;
    const {
      isLoading,
      dateRange,
      availabilities,
      nextAvailability,
      startDate,
    } = this.state;

    return (
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12} className={classes.availabilityRange}>
          <DateRange
            provider={provider}
            startDate={startDate}
            setDateRange={this.setDateRange}
            obKey={obKey}
            objKey={objKey}
            nxKey={nxKey}
          />
        </Grid>

        {isLoading || Loading ? (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            className={classes.emptyGrid}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <Grid item xs={11}>
            {this.hasNoAvailability() ? (
              <NoAvailability
                provider={provider}
                nextAvailability={nextAvailability}
                fastForwardDateRange={this.fastForwardDateRange}
                referPatientCallback={referPatientCallback}
              />
            ) : (
              <AvailabilitySlots
                provider={provider}
                dateRange={dateRange}
                availabilities={availabilities}
                appointmentSelected={appointmentSelected}
              />
            )}
          </Grid>
        )}
      </Grid>
    );
  }
}

const styles = () => ({
  emptyGrid: {
    minHeight: '316px', // This number is height of the grid container minus the height of the date range
  },
  availabilityRange: {
    textAlign: 'center',
    marginBottom: '24px',
  },
  defaultButton: {
    backgroundColor: '#0077bd',
  },
  emptyAvailabilityButton: {
    width: '87px',
    height: '37px',
    marginBottom: '8px',
    padding: '8px 16px',
    color: 'white',
    borderRadius: '2px',
    fontSize: '14px',
    lineHeight: '21px',
    border: '1px solid #C9C9C9',
  },
});

AvailabilityGrid.propTypes = {
  provider: PropTypes.object.isRequired,
  appointmentSelected: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  isSearchPage: PropTypes.bool,
};

export default withStyles(styles)(AvailabilityGrid);
